import { OBJECTIVES_COLORS } from "@amplio-common/vocabulary/constants";
import uniqBy from "lodash/uniqBy";

export const getSoundFilterObject = (allSounds, selectedSounds, selectedSoundPositions) => {
  const groups = [];
  const items = [];
  const positions = [...selectedSoundPositions];

  selectedSounds?.forEach(selectedSound => {
    if (selectedSound?.startsWith("g-")) {
      const g = allSounds.groups.find(group => group.value === selectedSound);
      groups.push({
        id: g.id,
        type: g.subGroup,
        group: g.label,
        sound: g.items.map(item => (item.name)),
      });
    } else {
      const i = allSounds.items.find(item => item.value === selectedSound);
      i && items.push({
        sound: i.name,
        type: i.subGroup,
        group: i.group,
      });
    }
  });

  return { items, groups, positions };
};

export const getCategoryFilterObject = (allCategories, selectedCategories) => {
  const groups = [];

  selectedCategories?.forEach(selectedCategory => {
    if (selectedCategory?.startsWith("g-")) {
      const g = allCategories?.groups?.find(group => group.value === selectedCategory);
      g && groups.push({
        id: g.id,
        category: g.label,
        sub_categories: g.items.map(item => item.name),
        full_category: true,
      });
    } else {
      const i = allCategories.items.find(item => item.value === selectedCategory);
      i && groups.push({
        id: i.category_id,
        category: i.category,
        sub_categories: [i.name],
        full_category: false,
      });
    }
  });

  return { groups };
};

export const getFilterdGamesList = (allGames, searchText) => {
  // Free Text
  const lowerSearchText = searchText.replace(/\s\s+/g, " ").trim().toLowerCase();
  const gamesByText = !lowerSearchText ? allGames : allGames.filter(
    (game) => game?.title?.replace(/\s\s+/g, " ").trim().toLowerCase().includes(lowerSearchText)
      || game?.objective_title?.toLowerCase().includes(lowerSearchText),
  );
  return gamesByText;
};

const getObjectivesColors = (objectives) => {
  let lastIndex = 0;
  const colors = {};
  objectives.forEach(objective => {
    colors[objective] = OBJECTIVES_COLORS[lastIndex];
    lastIndex += 1;
    if (lastIndex >= OBJECTIVES_COLORS.length) { lastIndex = 0; }
  });
  return colors;
};

const getKey = (a, b) => (`${a}_${b}`);

export const serializedAreaOfNeeds = (list) => {
  const objectiveTitles = new Set();
  const gamesRelations = {};
  list?.forEach((areaOfNeed) => {
    const protocols = uniqBy(
      areaOfNeed?.area_of_need_set?.reduce((acc, x) => [...acc, ...x.protocols], []) || [],
      "id",
    );
    areaOfNeed.protocols = protocols;
    areaOfNeed?.protocols?.forEach((protocol) => {
      protocol?.objectives?.forEach((objective) => {
        objectiveTitles.add(objective.name);
        objective.games.forEach(gameId => {
          gamesRelations[getKey(gameId, objective.id)] = {
            area_id: areaOfNeed.id,
            area_title: areaOfNeed.name,
            protocol_id: protocol.id,
            protocol_title: protocol.name,
          };
        });
      });
    });
  });

  return {
    areasOfNeed: list,
    gamesRelations,
    objectivesColors: getObjectivesColors(Array.from(objectiveTitles)),
  };
};

export const getGamesListWithIcons = (games) => games.filter(game => game?.thumbnail_file);

export const getGamesWithMetaData = (games) => {
  const all = [];
  games && games.forEach(game => {
    game?.game_metadata?.forEach(data => {
      all.push({ ...game, ...data });
    });
  });
  return all;
};

export const getGroupedGamesList = (games, selectedFilter, protocolToObjectiveDict, fieldToObjectiveDict) => {
  const groupsObj = {};
  const protocol = selectedFilter?.protocol;
  const field = selectedFilter?.areaOfNeed;

  games && games.forEach(game => {
    const { objective_title, objective } = game;

    if (field && !fieldToObjectiveDict[field].includes(objective)) {
      return;
    }

    if (protocol && !protocolToObjectiveDict[protocol].includes(objective)) {
      return;
    }

    const group = groupsObj[objective_title] || { objective_id: objective, title: objective_title, games: [] };
    group.games.push({ ...game, areaOfNeed: field });
    groupsObj[objective_title] = group;
  });
  return Object.values(groupsObj).sort((a, b) => a.objective_id > b.objective_id ? 1 : -1);
};

export const getIsCategoryFilter = (game) => (game?.is_manual && game?.is_naming) || (!game?.is_manual && (game?.is_naming || !game?.is_articulation));
export const getIsSoundFilter = (game) => (game?.is_manual && game?.is_articulation) || (!game?.is_manual && (game?.is_articulation || !game?.is_naming));
